/* tslint:disable */
import {Injectable} from '@angular/core';
import * as THREE from 'three';
import {STLLoader} from "three/examples/jsm/loaders/STLLoader";
import {environment} from "../../../../environments/environment";
import {Link, Node} from "../../neurons/neuronsModels";
import {WebGLService} from "./web-gl.service";
import {Color} from "../../drawingDataModels";
import {Font, FontLoader, TextGeometry} from "three";

@Injectable({
    providedIn: 'root'
})
export class MeshService {

    static instance: MeshService; //Singleton pattern

    roiGeometry = new THREE.SphereGeometry(1, 24, 18);
    sphereGeometry = new THREE.SphereGeometry(1, 10, 10);
    cylinderGeometry = new THREE.CylinderGeometry(1, 1, 1, 20, 20);

    constructor(private webGLService: WebGLService) {
        MeshService.instance = this;
    }

    getMeshCenter(mesh) {
        let center = new THREE.Vector3();
        let geometry = mesh.geometry;

        geometry.computeBoundingBox();

        center.x = (geometry.boundingBox.max.x + geometry.boundingBox.min.x) / 2;
        center.y = (geometry.boundingBox.max.y + geometry.boundingBox.min.y) / 2;
        center.z = (geometry.boundingBox.max.z + geometry.boundingBox.min.z) / 2;

        mesh.localToWorld(center);
        return center;
    }

    async createMesh(stlFileURL, color, opacity, offset) {
        let material = new THREE.MeshPhongMaterial({
            wireframe: false,
            color: color,
            transparent: true,
            opacity: opacity,
            depthTest: false,
        });

        let mesh = await this.loadSTLFile(stlFileURL, material);
        // Mimi Offset
        mesh.position.sub(offset);

        return mesh;
    }

    async loadSTLFile(stlFilePath, material) {
        let backendSTLFilePath = environment.mediaURL + stlFilePath;
        let loader = new STLLoader()

        let geometry = await loader.loadAsync(backendSTLFilePath);

        geometry.normalizeNormals();

        return new THREE.Mesh(geometry, material);
    }

    createROIMesh(position: THREE.Vector3, scale: THREE.Vector3, color: Color, opacity: number, sceneClippingPlanes) {
        let ROIMesh = new THREE.Mesh(this.roiGeometry, new THREE.MeshBasicMaterial({
            color: color.hex,
            opacity: opacity,
            transparent: true,
            visible: true,
            // clippingPlanes: scene_clipping_planes,
            // clipShadows: true
        }));
        if (position !== null) {
            ROIMesh.position.copy(position);
        }

        ROIMesh.scale.set(scale.x, scale.y, scale.z);

        return ROIMesh;

    }


    computeParentChildVectors(nodes, index, parentValue) {


        // Parent ID needs to be adjusted for zero-based array
        // Since SWC parent IDs start at 1, but JavaScript array indices start at 0, you need to subtract 1 from the parent ID to find the correct position in the array.
        let parentIndex = parentValue - 1; // Convert 1-based ID to 0-based index

        let childPosition = new THREE.Vector3(
            nodes._3d.x[index],
            nodes._3d.y[index],
            nodes._3d.z[index],
        );

        let parentPosition = new THREE.Vector3(
            nodes._3d.x[parentIndex],
            nodes._3d.y[parentIndex],
            nodes._3d.z[parentIndex],
        );

        return {childPosition, parentPosition};
    }

    createNeuronMeshLines(nodes, color: Color, sceneClippingPlanes) {
        let lineMaterial = new THREE.LineBasicMaterial({
            color: color.hex,
            clippingPlanes: sceneClippingPlanes,
            clipShadows: true
        });

        let neuronsPoints = [];

        // Recreate the Links array
        for (let index = 0; index < nodes.parent.length; index++) {
            let parentValue = nodes.parent[index];

            // Skip root node (-1 has no parent)
            if (parentValue === -1) {
                continue;
            }
            let {childPosition, parentPosition} = this.computeParentChildVectors(nodes, index, parentValue);

            neuronsPoints.push(parentPosition);
            neuronsPoints.push(childPosition);
        }

        let lineGeometry = new THREE.BufferGeometry().setFromPoints(neuronsPoints);
        let lineSegments = new THREE.LineSegments(lineGeometry, lineMaterial);

        this.webGLService.alignMeshToReferencePosition(lineSegments);
        return lineSegments;
    }

    createLinkPointsList(nodes, neuronPoints, resolution) {
        // Recreate the Links array
        for (let index = 0; index < nodes.parent.length; index++) {

            let parentValue = nodes.parent[index];

            // Skip root node (-1 has no parent)
            if (parentValue === -1) {
                continue;
            }

            let {childPosition, parentPosition} = this.computeParentChildVectors(nodes, index, parentValue);

            neuronPoints.push(parentPosition);
            // neuronPoints.push(childPosition); // MIMI NEW added this,
            // commented this for testing something
            let distance = parentPosition.distanceTo(childPosition);
            let compartments = distance / resolution;
            let step = 1 / compartments;

            for (let j = 0; j < 1; j += step) {
                neuronPoints.push(this.getNextPointPosition(parentPosition.clone(), childPosition.clone(), j));
            }
        }
        return neuronPoints
    }

    createNeuronMeshPoints(nodes, color: Color, resolution: number, thickness: number) {
        let materials = new THREE.PointsMaterial({
            size: thickness,
            depthTest: true,
            transparent: false,
            color: color.hex,
            // clippingPlanes: sceneClippingPlanes,
            // clipShadows: true
        });

        let neuronPoints = [];

        neuronPoints = this.createLinkPointsList(nodes, neuronPoints, resolution);

        let geometry = new THREE.BufferGeometry().setFromPoints(neuronPoints);
        let pointsMesh = new THREE.Points(geometry, materials);

        this.webGLService.alignMeshToReferencePosition(pointsMesh);

        // //  Draw neurons IDs on the 3D brain
        // const labelMeshes: THREE.Mesh[] = [];
        // console.log("nodes ===>", nodes);
        // const loader = new FontLoader();
        // loader.load('https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', (font: Font) => {
        //     for (let i = 0; i < nodes.parent.length; i++) {
        //         const id = String(i);
        //
        //         const geometry = new TextGeometry(id, {
        //             font: font,
        //             size: 0.2,
        //             height: 0.1,
        //         });
        //
        //         const material = new THREE.MeshBasicMaterial({color: 0xffffff});
        //         const textMesh = new THREE.Mesh(geometry, material);
        //
        //         textMesh.position.set(
        //             nodes['_3d']['x'][i] - this.webGLService.referencePosition.x,
        //             nodes['_3d']['y'][i] - this.webGLService.referencePosition.y,
        //             nodes['_3d']['z'][i] - this.webGLService.referencePosition.z
        //         );
        //         textMesh.rotation.set(0, 0, Math.PI);
        //
        //         this.webGLService.addToScene(textMesh);
        //         labelMeshes.push(textMesh); // Track for camera-facing
        //     }
        // });


        return pointsMesh;
    }


    createLinkCylinderList(nodes, neuronGroup, material, thickness) {
        // Recreate the Links array
        for (let index = 0; index < nodes.parent.length; index++) {

            let parentValue = nodes.parent[index];

            // Skip root node (-1 has no parent)
            if (parentValue === -1) {
                continue;
            }

            let {childPosition, parentPosition} = this.computeParentChildVectors(nodes, index, parentValue);

            let joint = new THREE.Mesh(this.sphereGeometry, material);
            joint.position.copy(childPosition);
            joint.scale.set(thickness, thickness, thickness);

            let cylinder = this.drawCylinder(parentPosition, childPosition, thickness, thickness, material);

            neuronGroup.add(joint);
            neuronGroup.add(cylinder);

        }
        return neuronGroup
    }

    drawNeuronCylinder(nodes, color: Color, thickness: number) {

        let material = new THREE.MeshPhongMaterial({
            wireframe: false,
            color: color.hex,
            // clippingPlanes: sceneClippingPlanes,
            // clipShadows: true
        });

        let neuronGroup = new THREE.Group();
        this.createLinkCylinderList(nodes, neuronGroup, material, thickness)

        this.webGLService.alignMeshToReferencePosition(neuronGroup);

        return neuronGroup;
    }

    createSomaMesh(somaPosition: THREE.Vector3, somaSize: number, color: Color, sceneClippingPlanes) {

        let material = new THREE.MeshPhongMaterial(
            {
                wireframe: false,
                color: color.hex,
                clippingPlanes: sceneClippingPlanes,
                clipShadows: true
            });

        let somaMesh = new THREE.Mesh(this.sphereGeometry, material);

        somaMesh.position.set(somaPosition.x, somaPosition.y, somaPosition.z);
        somaMesh.scale.set(somaSize, somaSize, somaSize);

        this.webGLService.alignMeshToReferencePosition(somaMesh);
        return somaMesh;
    }

    drawCylinder(start, end, radiusStart, radiusEnd, material) {
        let direction = new THREE.Vector3();
        direction.subVectors(end, start);

        let midVector = start.add(end);

        let mesh = new THREE.Mesh(this.cylinderGeometry, material);
        mesh.scale.set(radiusStart, direction.length(), radiusEnd);
        let axis = new THREE.Vector3(0, 1, 0);
        mesh.quaternion.setFromUnitVectors(axis, direction.clone().normalize());

        mesh.position.copy(midVector.clone().multiplyScalar(0.5));

        return mesh;
    }

    getNextPointPosition(start, end, step) {
        let directionVectorFromStartToEnd = new THREE.Vector3();

        //Direction from the start to the end
        directionVectorFromStartToEnd.subVectors(end, start);
        directionVectorFromStartToEnd.multiplyScalar(step);

        let result = new THREE.Vector3();
        result.addVectors(start, directionVectorFromStartToEnd);

        return result;
    }

    alignNeuronMeshToBrain(neuron) {
        this.webGLService.alignMeshToReferencePosition(neuron.meshes.soma);
        this.webGLService.alignMeshToReferencePosition(neuron.meshes.full);
    };


    async loadSWCFile(filePath) {

        try {
            let neuronFilePath = environment.mediaURL + filePath;
            let rawFile = new XMLHttpRequest();

            let center = new THREE.Vector3(0, 0, 0);
            let links: Link[] = [];
            let nodes: { number: Node };
            // @ts-ignore
            nodes = {};
            let nodesCount = 0;
            rawFile.open('GET', neuronFilePath, false);
            rawFile.onreadystatechange = function () {

                if (rawFile.readyState === 4) {
                    if (rawFile.status === 200 || rawFile.status === 0) {
                        let allText = rawFile.responseText;

                        let lines = allText.split('\n');

                        for (let i = 0; i < lines.length; i += 1) {
                            let lineData = lines[i].split(' ');
                            if (lineData.length === 7) {
                                if (lineData[0] !== '#') {
                                    let nodeID = parseInt(lineData[0]);
                                    let parentID = parseInt(lineData[6]);

                                    let node = new Node(
                                        nodeID,
                                        parseInt(lineData[1]),
                                        new THREE.Vector3(parseFloat(lineData[2]), parseFloat(lineData[3]), parseFloat(lineData[4])),
                                        parseFloat(lineData[5]),
                                        null,
                                        []);

                                    nodes[nodeID] = node;

                                    nodesCount += 1;

                                    let parentNode = null;
                                    if (parentID !== -1) {
                                        parentNode = nodes[parentID];
                                        parentNode.addChild(node);
                                        links.push(new Link(parentNode, node));
                                    }
                                    node.parent = parentNode;
                                    center.add(node.position._3d);
                                }
                            }
                        }
                    }
                }
            };
            rawFile.send(null);

            center.divideScalar(nodesCount);

            return {
                nodes: nodes,
                links: links,
                center: center
            };
        } catch (e) {
            return null;
        }
    }

}
